// extracted by mini-css-extract-plugin
export var container = "navigation-module--container--1fh_q";
export var navigation = "navigation-module--navigation--tCgAu";
export var navigationItem = "navigation-module--navigationItem--3NUGy";
export var logoLink = "navigation-module--logoLink--2kbay";